// Firebase configuration for Network Management App
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB3SxXbOuGyagEP2MAeIjpJLC5h4ntqGSs",
  authDomain: "evaila-contacts.firebaseapp.com",
  projectId: "evaila-contacts",
  storageBucket: "evaila-contacts.firebasestorage.app",
  messagingSenderId: "1025562157848",
  appId: "1:1025562157848:web:fe062e5d6021a463e5346d"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();

export default app;
